export default __webpack_public_path__ + "static/media/Curio of the White Hand.51beed68.jpg";